console.log('Greetings from Media split text!');
